<template>
	<v-card>
		<v-card-title class="text-subtitle-1 headings py-2">
			Уреди в сесията
		</v-card-title>
		<v-simple-table dense>
			<thead>
			<tr>
				<th></th>
				<th>
					Тип,
					Номер,
					Локация
				</th>
				<th></th>
				<th class="px-0" width="1%"></th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="device in row.devices[field]" :key="device.device_data.id" :class="classDeviceRow(device)">
				<td>
					<device-type-icon :type="device.device_data.device_type_code"/>
				</td>
				<td>
					<v-icon color="green" v-if="device.model && device.model.is_radio==='1'" style="vertical-align: bottom;"
									title="Радио">mdi-wifi
					</v-icon>
					{{ device.device_data.device_N }}<br>
					<span class="grey--text">{{ DeviceTypeLabels.get(device.device_data.device_type_code) }} - {{ device.device.room }}</span>
				</td>
				<td>
					<edit-input-wrapper name="devices_transfer_data">
						<base-input
							class="ma-2"
							outlined
							dense
							type="decimal"
							required
							:disabled="loading"
							:value="row.devices_transfer_data[field][device.device_data.device_N] || null"
							@input="setDeviceValue(device.device_data.device_N, $event)"
						/>
					</edit-input-wrapper>
				</td>
				<td class="px-0">
					<device-info-popup :device="{
							d: device.device,
							dd: device.device_data,
							m: device.model || {},
						}"/>
				</td>
			</tr>
			</tbody>
		</v-simple-table>
	</v-card>
</template>

<script>
import {DeviceType, DeviceTypeLabels} from "@/ittijs/Nomenclatures";
import DeviceTypeIcon from "@/ittijs/components/DeviceDataList/DeviceTypeIcon.vue";
import DeviceInfoPopup from "@/ittijs/components/DeviceDataList/DeviceInfoPopup.vue";
import EditInputWrapper from "@/ittijs/Inputs/EditInputWrapper.vue";
import BaseInput from "@/ittijs/Inputs/BaseInput.vue";

export default {
	components: {
		BaseInput,
		EditInputWrapper,
		DeviceInfoPopup,
		DeviceTypeIcon,
	},
	props: {
		row: {},
		field: {},
		loading: {},
	},
	data() {
		return {
			DeviceTypeLabels,
			locked: true,
		}
	},
	methods: {
		setDeviceValue(device_N, newValue){
			this.$set(this.row.devices_transfer_data[this.field], device_N, newValue);
			this.$emit('input', newValue);

		},
		isDeviceHighlight(device){
			switch (device.device_data.device_type_code) {
				case DeviceType.VODOMER_COLD:
				case DeviceType.VODOMER_HOT:
					return true;
			}
			return false;
		},
		isDeviceHighlightBottom(device){
			switch (device.device_data.device_type_code) {
				case DeviceType.SHTRANGLIRA:
				case DeviceType.ETALON_SLAVE:
				case DeviceType.RADIATOR_BEZ_URED:
					return true;
			}
			return false;
		},
		classDeviceRow(device){
			return {
				"orange lighten-5"   : !this.$vuetify.theme.dark && this.isDeviceHighlight(device),
				"cyan darken-4"      : this.$vuetify.theme.dark && this.isDeviceHighlight(device),
				"purple lighten-5"   : !this.$vuetify.theme.dark && this.isDeviceHighlightBottom(device),
				"purple darken-3"    : this.$vuetify.theme.dark && this.isDeviceHighlightBottom(device),
			};
		},
	},
}
</script>